export default __webpack_public_path__ + "static/media/no_photo_male.e1193cc3.jpg";